var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportantsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gpp_maybe_FILL1_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9997 25.3333C19.4483 25.3333 19.8243 25.1816 20.1278 24.8781C20.4313 24.5746 20.583 24.1986 20.583 23.75C20.583 23.3013 20.4313 22.9253 20.1278 22.6218C19.8243 22.3184 19.4483 22.1666 18.9997 22.1666C18.5511 22.1666 18.175 22.3184 17.8715 22.6218C17.5681 22.9253 17.4163 23.3013 17.4163 23.75C17.4163 24.1986 17.5681 24.5746 17.8715 24.8781C18.175 25.1816 18.5511 25.3333 18.9997 25.3333ZM17.4163 19H20.583V11.0833H17.4163V19ZM18.9997 34.8333C15.3316 33.9097 12.3035 31.8052 9.9153 28.5198C7.52711 25.2343 6.33301 21.5861 6.33301 17.575V7.91663L18.9997 3.16663L31.6663 7.91663V17.575C31.6663 21.5861 30.4722 25.2343 28.084 28.5198C25.6959 31.8052 22.6677 33.9097 18.9997 34.8333Z",
    fill: "#126496"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantsign);
export default __webpack_public_path__ + "static/media/importantsign.19b15a686b624725d00f79dbc7cfdbfb.svg";
export { ForwardRef as ReactComponent };